import React from 'react';
import { LockIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function LeadershipStandards() {
  return <SectionWrapper hasDivider glowPosition="center" data-id="element-117">
      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-118">
        <div data-id="element-119">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6" data-id="element-120">
            Leadership must remain continuously earned
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed" data-id="element-121">
            High-trust roles in government, law, security, and institutional
            leadership require continuously maintained standards of judgment,
            psychological stability, and civic responsibility. Authority is not
            assumed to be permanent. It is maintained only through demonstrated
            competence over time.
          </p>
        </div>

        <div className="relative" data-id="element-122">
          <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 to-teal-500 rounded-2xl blur opacity-20" data-id="element-123" />
          <div className="relative bg-[#060a14] border-l-4 border-cyan-400 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-124">
            <LockIcon className="w-8 h-8 text-cyan-400 mb-6 opacity-50" data-id="element-125" />
            <blockquote className="text-2xl md:text-3xl font-medium text-white leading-tight italic" data-id="element-126">
              "No enduring claim to power without enduring proof of judgment."
            </blockquote>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}